import { render, staticRenderFns } from "./GiveMedicationModal.vue?vue&type=template&id=7fc444ec&scoped=true"
import script from "./GiveMedicationModal.vue?vue&type=script&lang=js"
export * from "./GiveMedicationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc444ec",
  null
  
)

export default component.exports